<template>
<div class="card">
    <div class="card-header">Requester Review Posting</div>
    <div class="card-body">
        <form-summary :validator="$v" ref="errorContainer" id="errorContainer"/>

        <div v-if="hiringManagerOrSubmitter">
            <BaseStatusHelp lifecycleStatus="34"/>
            <b-row>
                <b-col cols="12">
                    <p>Please review the draft posting by downloading the draft document in the attachments below.<br/>
                    <p><strong>Upload your revisions and return back to HRM.</strong></p>
                </b-col>
            </b-row>

            <hr/>

            <b-row>
                <b-col cols="12">
                      <BaseTextOutput :value="request.draftPostingComments"
                                  label="Staffing Specialist Comments/Questions"/>
                </b-col>
            </b-row>

            <b-row>
                <b-col cols="12">
                      <BaseParagraphInput v-model="request.postingFeedback"
                          :v="$v.request.postingFeedback"
                          slug="draftPostingFeedback"
                          label="Your Feedback"/>                                  
                </b-col>
            </b-row>
                            
            <b-form @submit.stop.prevent="onSubmit">
                <div>
                    <b-button type="button" variant="primary" @click="submit">Return to HRM Specialist</b-button>
                </div>
            </b-form>
        </div>
        <div v-else>
            <b-col cols="12">
                <b-alert show>This request is currently being reviewed by the Requester.  Please wait their response.</b-alert> 
            </b-col>
        </div>
    </div>

    <!-- Return Modal -->
    <b-modal id="modal-return-previous-lifecycle" hide-header hide-footer @hidden="close">
        <h2>Return To Requester</h2>
        <hr/>
        <form ref="form" @submit.prevent="returnToRequester()">
            <BaseParagraphInput v-model="returnPreviousLifecycleComments"
                          :v="$v.returnPreviousLifecycleComments"
                          slug="returnPreviousLifecycleComments"
                          :required="$v.returnPreviousLifecycleComments.$params.required ? true : false"
                          label="Reason for Returning to Requester"/>
            <b-button @click="close" style="margin-right:15px;">Cancel</b-button>
            <b-button type="submit" variant="primary" :disabled="$v.returnPreviousLifecycleComments.$invalid">Submit</b-button>
        </form>
    </b-modal>
</div>

</template>

<script>
import axios from "axios"
import { required, email, minLength, maxLength, numeric, requiredIf } from 'vuelidate/lib/validators'
import { commonOptions } from '@/mixins/commonOptions.js'

export default {
    components: {
    },
    mixins: [       
       commonOptions
    ],
    props: {
        request: Object
    },
    data() {
        return {
            options: {
                format: 'YYYY-MM-DD',
                useCurrent: false,
            }, 
            saveOnly: false,
            returnPreviousLifecycleComments: null,
            hiringManagerOrSubmitter: false,
        }
    },
     validations: {
         request: {
             priority: { required: false },
             preHireConsultDate: { required },
             bargainingUnit: { required },
             assignmentComments: { required: false, maxLength: maxLength(4000) },  
             postingFeedback: { required: false, maxLength: maxLength(4000) },  
         },
         returnPreviousLifecycleComments: {required: false, maxLength: maxLength(4000)},
     },
    computed: { },
    created() { 
         this.hiringManagerOrSubmitter = (this.request.supervisor && this.request.supervisor.userId &&
                                         this.request.supervisor.userId.toLowerCase() === this.$keycloak.userName.toLowerCase()) ||
                                         (this.request.submitter && this.request.submitter.userId &&
                                         this.request.submitter.userId.toLowerCase() === this.$keycloak.userName.toLowerCase())
    },
    watch: { },

    methods: {        
        save() {
            this.saveOnly = true
            this.submit()
            this.saveOnly = false
        },
        
        showRootToast(title, message, type) {
            this.$root.$bvToast.toast(message, {
                  title: title,
                  toaster: 'b-toaster-top-center',
                  solid: true,
                  variant: type,
                  appendToast: true
                })

        },
        
        submit() {
            let payload = {
                requestId: this.request.id,
                postingFeedback: this.request.postingFeedback,  
                aadvanceNextLifecycle: !this.saveOnly
            }
        
            axios.post(`${process.env.VUE_APP_API_BASE_URL}/manager/return/specialist`, payload)
              .then(response => {
                this.showRootToast("HRM Request Has Been Sent to HRM Specialist", "Success", "success")
                this.$router.push('/home')
              })
        },

        close() {
          this.$bvModal.hide("modal-return-previous-lifecycle")
          this.returnPreviousLifecycleComments=null
        },
    }   
}
</script>